class OosToggle extends HTMLElement {
  static STORAGE_KEY = 'oosToggleExpanded';

  connectedCallback() {
    this.button = this.querySelector('[data-oos-toggle-button]');
    if (!this.button) return;

    this.mode = this.dataset.pickerType;
    this.hiddenItems =
      this.mode === 'dropdown'
        ? Array.from(this.querySelectorAll('option[data-oos-hidden]'))
        : Array.from(this.querySelectorAll('.oos-check.hidden'));

    if (this.hiddenItems.length === 0) return;

    this.showText = this.button.dataset.showText;
    this.hideText = this.button.dataset.hideText;

    this.button.classList.remove('hidden');
    this.button.addEventListener('click', () => this.toggle());

    const wasExpanded = sessionStorage.getItem(OosToggle.STORAGE_KEY) === 'true';
    this.applyState(wasExpanded);
  }

  toggle() {
    const isExpanded = this.button.dataset.expanded !== 'true';
    sessionStorage.setItem(OosToggle.STORAGE_KEY, isExpanded ? 'true' : 'false');
    this.applyState(isExpanded);
  }

  applyState(isExpanded) {
    if (this.mode === 'dropdown') {
      this.hiddenItems.forEach((option) => {
        option.hidden = !isExpanded;
      });
    } else {
      this.hiddenItems.forEach((item) => item.classList.toggle('hidden', !isExpanded));
      if (isExpanded) this.pushToEnd();
    }

    this.button.dataset.expanded = isExpanded ? 'true' : 'false';
    this.button.textContent = isExpanded
      ? `${this.hideText} (${this.hiddenItems.length})`
      : `${this.showText} (${this.hiddenItems.length})`;
  }

  // Moves sold-out swatches/buttons after the in-stock ones, keeping the toggle button last
  pushToEnd() {
    this.hiddenItems.forEach((item) => this.insertBefore(item, this.button));
  }
}

customElements.define('oos-toggle', OosToggle);
